import React from 'react'
//import SortableList, { SortableItem } from 'react-easy-sort'
//import arrayMove from 'array-move'
import AgentStats from './AgentStats'
import ContactStats from './ContactStats'
//import AgentAvailability from './AgentAvailability'
import ContactStatsCCP from './ContactStatsCCP'
import QueueStatistics from './QueueStatistics'
import AverageHandledTime from './AverageHandledTime';
import BreakTime from './BreakTime';
import LunchTime from './LunchTime';
import { agentSliceAction } from '../../store/agentSlice';
import { useSelector, useDispatch } from 'react-redux';
import { getAccount } from '../../utils/awsAPI';

const Widgets = () => {
    const agentSlice = useSelector((state: any) => { return state.agentSlice })
    const agentSnapshot = useSelector((state: any) => { return state.agentSlice.agentSnapshot })
    const dispatch = useDispatch();

    const addAccount = async () => {
            let agentAccount = (await getAccount(agentSnapshot.agentData?.configuration?.username))["accountName"];
        dispatch(agentSliceAction.setAgentAccount({agentAccount: agentAccount}));
    }

    if(agentSlice.agentARN === ""){
        const rawAgentARN = JSON.stringify(agentSnapshot?.agentData?.configuration?.agentARN);
        const agentARN = rawAgentARN.split("/").pop()?.slice(0, -1);
        dispatch(agentSliceAction.setAgentARN({agentARN: agentARN}));
    }

    if(agentSlice.agentAccount === ""){
        addAccount();
    }

    const [items, setItems] = React.useState([
        {
            id:1,
            name: <BreakTime/>
        },
        {
            id:2,
            name: <LunchTime/>
        },
        {
            id:2,
            name: <ContactStatsCCP/>
        },
        {
            id:4,
            name: <AgentStats/>
        },
        /*{
            id:5,
            name: <AgentAvailability/>
        },*/
        {
            id:6,
            name: <AverageHandledTime/>
        },
        {
            id:7,
            name: <ContactStats/>
        },
        {
            id:8,
            name:<QueueStatistics />
        }        
    ]);
    /*const onSortEnd = (oldIndex: number, newIndex: number) => {
        setItems((array) => arrayMove(array, oldIndex, newIndex))
    }*/
    /* <div className='container-fluid'>
        <SortableList onSortEnd={onSortEnd} className="list row" draggedItemClassName="dragged">
            {items.map((item) => (
                <SortableItem key={item.id}>
                    <div className={`${(item.id === 8)?"col-md-12":"col-md-6"}`}>{item.name}</div>
                </SortableItem>
            ))}
        </SortableList>
    */
    return (
    <div className="main-content">
        <div className='widgets-container'>

            {items.map((item) => (
                //<SortableItem key={item.id}>
                    <div className={`${(item.id === 8)?"Float-Large":"float-child"}`}>{item.name}</div>
                //</SortableItem>
            ))}

        </div>
    </div>
    )
}
export default Widgets